<template>
    <div>
        <transition
            enter-active-class="transition ease-out duration-100"
            enter-from-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-from-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95"
        >
            <SlideOver :show="image !== null" @close="image = null">
                <div class="w-full flex justify-center bg-gray-300">
                    <Preview :width="200" :height="200" :image="result.image" :coordinates="result.coordinates" />
                </div>

                <Cropper
                    ref="cropper"
                    class=""
                    :src="image"
                    @change="onChange"
                    :debounce="false"
                    :auto-zoom="true"
                    :stencil-size="{
                        width: 200,
                        height: 200,
                        aspectRatio: 1,
                    }"
                    image-restriction="stencil"
                    :stencil-component="$options.components.CircleStencil"
                />

                <div class="flex space-x-4 mt-5">
                    <AppButton
                        desired-action
                        element="button"
                        type="button"
                        @click="submit()"
                        :disabled="image === null || status === 'loading'"
                    >
                        {{ $t('messages.save') }}
                        <span v-if="status === 'loading'" class="ml-1 btn-spinner" />
                    </AppButton>
                    <AppButton element="button" type="button" @click="$refs.file.click()">
                        {{ $t('messages.select') }}
                    </AppButton>
                </div>
            </SlideOver>
        </transition>

        <input type="file" ref="file" @change="loadImage($event)" accept="jpeg" />

        <div class="flex space-x-4">
            <AppButton desired-action element="button" type="button" @click="$refs.file.click()">
                {{ $t('messages.select') }}
            </AppButton>
        </div>
    </div>
</template>

<script>
import { Cropper, Preview } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import axios from 'axios';
import AppButton from '@/components/AppButton.vue';
import SlideOver from '@/components/SlideOver.vue';

export default {
    components: {
        Cropper,
        Preview,
        AppButton,
        SlideOver,
    },
    data() {
        return {
            image: null,
            status: 'idle',
            result: {
                coordinates: null,
                image: null,
            },
        };
    },
    props: {
        endpoint: {
            type: String,
            default: '',
        },
    },
    methods: {
        reset() {
            this.image = null;
        },
        onChange({ coordinates, image }) {
            this.result = {
                coordinates,
                image,
            };
        },
        submit() {
            this.status = 'loading';
            const { canvas } = this.$refs.cropper.getResult();
            if (canvas) {
                const formData = new FormData();
                canvas.toBlob((blob) => {
                    formData.append('profile_photo_file', blob);
                    // You can use axios, superagent and other libraries instead here
                    axios
                        .post(this.endpoint, formData, {
                            headers: { 'Content-Type': 'multipart/form-data' },
                        })
                        .then(() => {
                            this.status = 'idle';
                            window.location.reload(true);
                        })
                        .catch(() => {
                            console.error('FAILURE!!');
                        });
                    // Perhaps you should add the setting appropriate file format here
                }, 'image/jpeg');
            }
        },
        loadImage(event) {
            // Reference to the DOM input element
            const input = event.target;
            // Ensure that you have a file before attempting to read it
            if (input.files && input.files[0]) {
                // create a new FileReader to read this image and convert to base64 format
                const reader = new FileReader();
                // Define a callback function to run, when FileReader finishes its job
                reader.onload = (e) => {
                    // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                    // Read image as base64 and set to imageData
                    this.image = e.target.result;
                };
                // Start the reader job - read file as a data url (base64 format)
                reader.readAsDataURL(input.files[0]);
            }
        },
    },
};
</script>
